import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { OrderSummary } from '../../../shared/interfaces/order-summary';
import { PaymentSuffixPipe } from '../../../shared/pipes/payment-suffix.pipe';

@Component({
    selector: 'app-total-summary',
    standalone: true,
    imports: [CommonModule, PaymentSuffixPipe],
    templateUrl: './total-summary.component.html',
    styleUrl: './total-summary.component.scss',
})
export class TotalSummaryComponent {
    @Input({ required: true }) public summary!: OrderSummary;
}
